import 'react-day-picker/style.css'
import { DayPicker } from 'react-day-picker'
import { es } from 'date-fns/locale/es'

import { cn } from '@lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

// Compact month calendar. The selected/accent color follows the app theme
// (--ml-primary), so it matches the chosen interface color.
export function Calendar({ className, style, ...props }: CalendarProps) {
  return (
    <DayPicker
      locale={es}
      showOutsideDays
      className={cn('p-3 text-sm', className)}
      style={
        {
          '--rdp-accent-color': 'rgb(var(--ml-primary))',
          '--rdp-accent-background-color': 'rgb(var(--ml-primary) / 0.12)',
          '--rdp-day-width': '2.1rem',
          '--rdp-day-height': '2.1rem',
          '--rdp-day_button-width': '2.1rem',
          '--rdp-day_button-height': '2.1rem',
          // Caller overrides (e.g. smaller sizing) merge on top of the defaults.
          ...style,
        } as React.CSSProperties
      }
      {...props}
    />
  )
}
